(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Best_sellers"] && !Shopify.designMode) return;
  try {
    

mobileOnlySlider(".mySlidernn", true, false, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: true,
		arrows: true,
        loop:true,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider

  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FAQ_New"] && !Shopify.designMode) return;
  try {
    
  
const accordionBtns = document.querySelectorAll(".item-header");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("active");

    let content = this.nextElementSibling;
    console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      console.log(content.style.maxHeight);
    }
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Pga-pro-reviews"] && !Shopify.designMode) return;
  try {
    
  $('.owl-carousel-new').slick({
  centerMode: true,
  center: true,
  items: 3,
  centerPadding: '60px',
  slidesToShow: 3,
  nav:true,
  arrows: true,
  dots:true,
  loop:true,
  prevArrow: $('.pre'),
  nextArrow: $('.nex'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        nav:true,
        arrows: true,
        centerMode: true,
        center: true,
        centerPadding: '0px',
        slidesToShow: 1,
        adaptiveHeight: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        nav:true,
        arrows: true,
        centerMode: true,
        center: true,
        centerPadding: '20px',
        slidesToShow: 1 ,
        adaptiveHeight: true
      }
    }
  ]
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Review-Slider"] && !Shopify.designMode) return;
  try {
    
   const swiper = new Swiper(".swiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      nav:true,
      grabCursor: true,
      centeredSlides: false,
      pagination:true,
      slideActiveClass: "active",
      navigation: {
      nextEl: ".nexts",
      prevEl: ".prevs"
      },
      pagination: {
      el: ".pagination",
      clickable: true
      },
      autoplay: {
      enabled: true,
      delay: 5000
      },
        breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
          pagination:false,
          loop:false,
        },
      },
      
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  
 $('.owl-carousel').slick({
  centerMode: true,
  center: true,
  items: 3,
  centerPadding: '60px',
  slidesToShow: 3,
  dots:true,
  loop:true,
  prevArrow: $('.prev'),
  nextArrow: $('.next'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 3,
        adaptiveHeight: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1 ,
        adaptiveHeight: true
      }
    }
  ]
});
  

  } catch(e) { console.error(e); }
})();
})();
